import * as Reducer from './slice';

export interface IAppState {
  // this feature state
  [Reducer.statePropName]: Reducer.IUnityState;
  // other features we don't care of
  [otherKeys: string]: any;
}

const getFeatureState = (state: IAppState) => state[Reducer.statePropName];

export const isUnityStarted = (state: IAppState) => getFeatureState(state).started;

export const getUnityProgress = (state: IAppState) => getFeatureState(state).progress;

export const getCurrentExerciseId = (state: IAppState) => getFeatureState(state).exerciseId;

export const getCurrentExerciseType = (state: IAppState) => getFeatureState(state).exerciseType;

export const getAssessmentRun = (state: IAppState) => getFeatureState(state).assessmentRun;

export const isRunning = (state: IAppState) => getFeatureState(state).running;

export const getBalancing = (state: IAppState) => getFeatureState(state).balancing;

export const getMaxDifficulty = (state: IAppState) => {
  const balancing = getBalancing(state);
  return balancing ? balancing.exercise.exerciseConfig.maxD : 0;
};

export const getMinDifficulty = (state: IAppState) => {
  const balancing = getBalancing(state);
  return balancing ? balancing.exercise.exerciseConfig.minD : 0;
};

export const getCurrentRunningMode = (state: IAppState) => getFeatureState(state).mode;
